<template>
	<div v-if="!isLoading">
		<div class="main">
			<div>
				{{ $t('media_permission_hint') }}
			</div>
			<div class="flex mt-6">
				<div class="font-bold mr-4 text-lg w-56">{{ $t('videos') }}</div>
				<Toggle :active="videoPermission.perm_value" @click.native.prevent="changeValue(videoPermission)" />
			</div>
			<div class="flex mt-2">
				<div class="font-bold mr-4 text-lg w-56">{{ $t('images') }}</div>
				<Toggle :active="imagePermission.perm_value" @click.native.prevent="changeValue(imagePermission)" />
			</div>
			<div class="flex mt-2">
				<div class="font-bold mr-4 text-lg w-56">{{ $t('documents') }}</div>
				<Toggle :active="filePermission.perm_value" @click.native.prevent="changeValue(filePermission)" />
			</div>
		</div>
		<div class="flex justify-end">
			<BaseButton @click="save" :disabled="disabled || isLoading" class="btn-blue">{{ $t('general.save') }}</BaseButton>
		</div>
	</div>
	<LoadingSpinner v-else />
</template>

<script>
import Authentication from '@/mixins/Authentication';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import Toggle from '@/components/forms/Toggle.vue';
import BaseButton from '@/components/forms/buttons/BaseButton.vue';
import CustomerPermissionsRepository from '@/api/repositories/CustomerPermissionsRepository';

export default {
	name: 'CustomerPermissionModal',
	mixins: [Authentication],
	components: { BaseButton, Toggle, LoadingSpinner },
	data() {
		return {
			isLoading: true,
			disabled: true,
			permissionId: null,
			imagePermission: {
				perm_value: false,
				id: null,
			},
			videoPermission: {
				perm_value: false,
				id: null,
			},
			filePermission: {
				perm_value: false,
				id: null,
			},
		};
	},
	mounted() {
		if (!this.isUserAllowedInLevel5or6) {
			this.$emit('authNotAllowed');
		} else {
			this.getCustomerPermissions();
		}
	},
	methods: {
		getCustomerPermissions() {
			CustomerPermissionsRepository.show(this.$route.params.customer)
				.then(response => {
					this.permissionId = response.data.data.id;
					this.videoPermission.perm_value = response.data.data.send_video;
					this.imagePermission.perm_value = response.data.data.send_image;
					this.filePermission.perm_value = response.data.data.send_file;
					this.isLoading = false;
				})
				.catch(error => {
					this.$swal(this.$t('general.error').toString(), this.$t('error_occurred').toString(), 'error');
				});
		},
		changeValue(permission) {
			permission.perm_value = !permission.perm_value;
			this.disabled = false;
			this.$store.commit('setConfirmLeaving', this.$t('leave_page'));
		},
		save() {
			CustomerPermissionsRepository.updatePermissions(this.permissionId, {
				send_image: this.imagePermission.perm_value,
				send_video: this.videoPermission.perm_value,
				send_file: this.filePermission.perm_value,
			})
				.then(response => {
					this.$store.commit('setConfirmLeaving', false);
					this.disabled = true;
					this.$swal(this.$t('general.success').toString(), this.$t('general.changes_saved').toString(), 'success');
				})
				.catch(error => {
					this.$swal(this.$t('general.error').toString(), this.$t('general.changes_not_saved').toString(), 'error');
				});
		},
	},
};
</script>

<style scoped></style>
